module.exports = __webpack_public_path__ + "static/media/00_Logo_UN_Indonesia_-_2021-05 (1).aa4d8b76.png";